export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  {
    name: "Our Services",
    children: [
      {
        name: "Healthcare Consulting",
        path: "/services",
        collapsible: true,
        children: [
          { name: "Workforce Development", path: "/services/workforce-development" },
          { name: "Compliance & Credentialing", path: "/services/compliance-credentialing" },
          { name: "EHR Implementation", path: "/services/ehr-implementation" },
          { name: "Patient Experience", path: "/services/patient-experience" },
          { name: "Clinic Operations", path: "/services/clinic-operations" },
          { name: "Growth & Scalability", path: "/services/growth-scalability" },
        ],
      },
      { name: "Life Sciences Consulting", path: "/life-sciences" },
      { name: "Administrative Services", path: "/administrative-services" },
      {
        name: "Signature Programs",
        collapsible: true,
        children: [
          { name: "CareRevive Initiative", path: "/programs/carerevive" },
          { name: "Foundations First", path: "/programs/foundations-first" },
          { name: "Concierge Frontline", path: "/programs/concierge-frontline" },
        ],
      },
    ],
  },
  {
    name: "Vendor Partnerships",
    children: [
      { name: "EHR Vendor Partnership", path: "/ehr-partnership" },
      { name: "RCM Vendor Partnership", path: "/rcm-partnerships" },
    ],
  },
  { name: "Get a Quote", path: "/quote" },
  { name: "Careers", path: "https://rnbconsultinggroup.zohorecruit.com/jobs/Careers", external: true },
  { name: "Contact", path: "/contact" },
];

export const getDashboardPath = (role) => {
  if (role === "admin" || role === "consultant" || role === "super_admin") return "/admin";
  if (role === "business_dev") return "/sales";
  if (role === "sdr") return "/sdr";
  return "/portal";
};
